export * from './TestedPartyCharacterization.proptype';

import { TestedPartyCharacterization as Component } from './Components/TestedPartyCharacterization';
import Connector from './connector';

export const TestedPartyCharacterization = () => <Connector component={Component} />;
